import React, { useState, useEffect, useMemo, useTransition } from 'react';
import { useSelector } from 'react-redux';
import { LeftSideMainContainer } from "./LeftSideMainContainer";
import { LeftSideContent } from "./components/LeftSideContent";
import LeftSideHeader from "./components/LeftSideHeader";
import { LeftSideList } from "./components/LeftSideList";
import { LeftSideFooter } from "./components/LeftSideFooter";
import LeftSideItem from "../LeftSideItem/LeftSideItem";
import { useLocation } from "react-router-dom";
import { getMenuExpeditor, getMenuClient } from "./mock";
import LoaderProgress from '../loader-progress/LoaderProgress';
import { useTranslation } from 'react-i18next';

const LeftSideMain = ({ className, isOpen = false, onCloseMenu }) => {
  const location = useLocation();
  const { navigation } = useSelector(state => state);
  const [isExpand, setIsExpand] = useState(isOpen);
  const [activeRouteName, setActiveRouteName] = useState(location.pathname);
  const user = useSelector(state => state.user);
  const { t } = useTranslation();

  const essentialLinks = useMemo(() => {
    return user?.type === "Expeditor" ? getMenuExpeditor(t) : getMenuClient(t);
  }, [user, t]);

  useEffect(() => {
    setIsExpand(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (essentialLinks.length && navigation && navigation.statuses) {
      const findIndex = essentialLinks.findIndex(m => m.isHasDropdownStatuses);
      if (findIndex !== -1) {
        essentialLinks[findIndex].children = navigation.statuses.map(i => ({
          title: i.statusName,
          link: `${essentialLinks[findIndex].link}?status=${i.status}`,
          status: i.status,
          count: i.count,
        }));
      }
    }
  }, [essentialLinks, navigation.statuses]);

  const toggleExpand = () => {
    setIsExpand(!isExpand);
    if (isExpand && onCloseMenu) {
        onCloseMenu();
    }
  };

  const onForceClose = () => {
    setIsExpand(false);
    if (isExpand && onCloseMenu) {
      onCloseMenu();
    }
  };

  return (
    <LeftSideMainContainer rootClassName={className}>
      <LeftSideContent isExpand={isExpand} onClose={() => onForceClose()}>
        <LeftSideHeader isExpand={isExpand} toggleExpand={toggleExpand} />
        <LeftSideList isExpand={isExpand}>

          {essentialLinks.map((link, idx) => {
            const isActive = activeRouteName === link.link;
            const iconWithType = React.cloneElement(link.icon, { type: isActive ? 2 : 1 });

            return (
              <LeftSideItem
                key={idx}
                item={{ ...link, icon: iconWithType }}
                displayText={isExpand}
                activeRouteName={activeRouteName}
                setActiveRouteName={setActiveRouteName}
                onForceClose={onForceClose}
                isExpand={isExpand}
              />
            );
          })}
        </LeftSideList>
    
        {/* <LeftSideFooter
          activeRouteName={activeRouteName}
          setActiveRouteName={setActiveRouteName}
          isExpand={isExpand}
          user={user}
          onForceClose={onForceClose}
        /> */}
      </LeftSideContent>
    </LeftSideMainContainer>
  );
};

export default LeftSideMain;